import * as THREE from 'three';
import { XRControllerModelFactory } from 'three/examples/jsm/webxr/XRControllerModelFactory';
import { XRHandModelFactory } from 'three/examples/jsm/webxr/XRHandModelFactory.js';
import CameraControls from 'camera-controls';
import CustomCameraControls from '@3jss/three-controls/CustomCameraControls';

CameraControls.install({ THREE });

/*
 * Methods commented out
 * - setupAutorotate
 * */

class ThreeController {
	setupControls(camera, renderer, orbitControlsConfig) {
		this.startDistance = null;
		this.camera = camera;

		this.controls = new CustomCameraControls(
			this.camera,
			renderer.domElement,
			orbitControlsConfig,
		);

		// if (window.count > 1) {
		renderer.domElement.addEventListener('touchend', (event) => {
			this.startDistance = null;
		});

		renderer.domElement.addEventListener('touchmove', (event) => {
			if (event.touches.length !== 1) {
				event.preventDefault();
			}
			if (
				event.touches.length === 2 &&
				!(
					orbitControlsConfig?.zoom &&
					orbitControlsConfig.zoom?.mobile === false
				)
			) {
				const base = Math.abs(
					event.touches[1].pageX - event.touches[0].pageX,
				);
				const height = Math.abs(
					event.touches[1].pageY - event.touches[0].pageY,
				);
				const dist = Math.sqrt(base ** 2 + height ** 2);
				const deltaDist = this.startDistance - dist;
				const temp = this.camera.fov + deltaDist * 0.2;
				// this.camera.position.x+=1;

				if (this.controls.enableZoom) {
					if (temp > 20 && temp < 70) {
						this.camera.fov += deltaDist * 0.2;
						this.camera.updateProjectionMatrix();
					}
				}

				this.startDistance = dist;
			}
		});

		window.c = this.controls;

		this.controls.enableZoom = true;
		this.controls.maxDistance = 0.1;
		this.controls.minDistance = 0;

		return this.controls;
	}

	setupPanControls = (enablePan = false, enableRotate = true) => {
		this.controls.enablePan = enablePan;
		this.controls.enableRotate = enableRotate;

		if (enablePan) {
			this.controls.panSpeed = 75.0;
			this.controls.screenSpacePanning = true;
			if (this?.controls?.touches) {
				this.controls.touches.ONE = THREE.TOUCH.PAN;
			}
		} else {
			if (this.controls?.touches) {
				this.controls.touches.ONE = THREE.TOUCH.ROTATE;
			}
		}

		// return this.controls;
	};

	setupRotation = (enabled) => {
		if (enabled) {
			this.controls.touches.one = CameraControls.ACTION.ROTATE;
			this.controls.mouseButtons.left = CameraControls.ACTION.ROTATE;
		} else {
			this.controls.touches.one = CameraControls.ACTION.NONE;
			this.controls.mouseButtons.left = CameraControls.ACTION.NONE;
		}
	};

	setupVRControls(renderer, dolly, scene) {
		const controllerModelFactory = new XRControllerModelFactory();
		const handModelFactory = new XRHandModelFactory();

		const geometry = new THREE.BufferGeometry().setFromPoints([
			new THREE.Vector3(0, 0, 0),
			new THREE.Vector3(0, 0, -1),
		]);

		// This is a temporary helper line to let the user aim at the objects in dolly
		const line = new THREE.Line(geometry);
		line.name = 'line';
		line.scale.z = 0;

		// Marker to detect intersections with 3D scenes
		const marker = new THREE.Mesh(
			new THREE.CircleGeometry(0.25, 32).rotateX(-Math.PI / 2),
			new THREE.MeshBasicMaterial({ color: 0xbcbcbc }),
		);
		marker.name = 'XR_Teleport_Marker';
		marker.visible = false;
		scene.add(marker);

		const vrControllers = []; // We return an arra for the 2 controllers
		const gripControls = [];
		const vrHands = [];
		const handModels = [];

		for (let i = 0; i <= 1; i++) {
			// Used for pointing in Z axis. Returns a THREEJS group
			const controller = renderer.xr.getController(i);
			controller.add(line.clone());
			controller.userData.selectPressed = false;
			dolly.add(controller);

			vrControllers.push(controller);

			// Used to manipulate objects in the 3D space with the controller. Returns a THREEJS group, these are the visual controllers
			const grip = renderer.xr.getControllerGrip(i);
			grip.name = 'XRControllerGrip';
			grip.add(controllerModelFactory.createControllerModel(grip));
			dolly.add(grip);

			gripControls.push(grip);

			// Hands
			const hand = renderer.xr.getHand(i);
			hand.name = 'XRHand';
			const model = handModelFactory.createHandModel(hand, 'mesh');
			hand.add(model);
			handModels.push(model);
			dolly.add(hand);

			vrHands.push(hand);
		}

		return { vrControllers, gripControls, vrHands, handModels };
	}
}

export default new ThreeController();
